import getLocalString from "constants/Localization";
import useBitumioMutation from "hooks/useBitumioMutation";
import { useUpdateOpportunityStatusesOrderingMutation } from "generated/graphql";
import { useCallback } from "react";

export default function useUpdateOpportunityStatusesOrdering() {
  const [mutation, { loading, data, error }] = useUpdateOpportunityStatusesOrderingMutation({
    refetchQueries: ["getOpportunityStatuses"],
  });

  const [updateOpportunityStatusesOrderingMutation, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "updateOpportunityStatusesOrdering",
    },
    {
      successMessage: getLocalString("opportunities.update-success"),
      failureMessage: getLocalString("opportunities.update-failure"),
    }
  );

  const updateOpportunityStatusesOrdering = useCallback(
    (statuses: { id: string; ordering: number }[]) => {
      return updateOpportunityStatusesOrderingMutation({ variables: { statuses } });
    },
    [updateOpportunityStatusesOrderingMutation]
  );

  return [updateOpportunityStatusesOrdering, context] as const;
}
